const Waze = ({ withWazeLink, setWithWazeLink, disabled = false, demoAllow = false }) => {

  return (
    <label className={`waze-smart-toggle ${disabled ? "waze-smart-toggle--disabled" : ""}`}>
      <span className="waze-smart-toggle__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path d="M12 21s6-5.5 6-11a6 6 0 1 0-12 0c0 5.5 6 11 6 11Z" /><circle cx="12" cy="10" r="2" /></svg>
      </span>
      <span className="waze-smart-toggle__text">
        <strong>קישור ניווט ב־WAZE</strong>
        <small>הוספת כפתור ניווט להזמנה</small>
      </span>
      <input
        type="checkbox"
        checked={Boolean(withWazeLink)}
        disabled={disabled}
        data-demo-allow={demoAllow ? "true" : undefined}
        onChange={(event) => setWithWazeLink(event.target.checked)}
      />
      <span className="waze-smart-toggle__switch" aria-hidden="true" />
    </label>
  );
};

export default Waze;
